import { Directive, ElementRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[redBooleanToSubscribed]',
  standalone: false
})
export class BooleanToSubscribedDirective implements OnChanges {
  @Input('redBooleanToSubscribed') enabled: boolean | null = false;

  element: ElementRef;

  constructor() {
    this.element = inject(ElementRef);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['enabled']) {
      switch (changes['enabled'].currentValue) {
        case true:
          this.element.nativeElement.innerText = 'Subscribed';
          this.element.nativeElement['color'] = 'success';
          break;
        default:
          this.element.nativeElement.innerText = 'Not Subscribed';
          this.element.nativeElement['color'] = 'danger';
          break;
      }
    }
  }
}
